var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30371 3.30408C2.08074 4.52705 1.49976 6.57321 1.49976 10.0001C1.49976 13.427 2.08074 15.4732 3.30371 16.6961C4.52669 17.9191 6.57287 18.5001 9.9998 18.5001C13.4267 18.5001 15.4729 17.9191 16.6958 16.6961C17.9188 15.4732 18.4998 13.427 18.4998 10.0001C18.4998 6.57321 17.9188 4.52705 16.6958 3.30408C15.4729 2.0811 13.4267 1.50012 9.9998 1.50012C6.57287 1.50012 4.52669 2.0811 3.30371 3.30408ZM2.24306 2.24341C3.91084 0.57564 6.48968 0.00012207 9.9998 0.00012207C13.5099 0.00012207 16.0887 0.57564 17.7565 2.24341C19.4243 3.91119 19.9998 6.49001 19.9998 10.0001C19.9998 13.5102 19.4243 16.089 17.7565 17.7568C16.0887 19.4246 13.5099 20.0001 9.9998 20.0001C6.48968 20.0001 3.91084 19.4246 2.24306 17.7568C0.575274 16.089 -0.000244141 13.5102 -0.000244141 10.0001C-0.000244141 6.49001 0.575274 3.91119 2.24306 2.24341Z",
    fill: "#323F48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0045 8.75C10.4187 8.75 10.7545 9.08579 10.7545 9.5V13.395C10.7545 13.8092 10.4187 14.145 10.0045 14.145C9.5903 14.145 9.25452 13.8092 9.25452 13.395V9.5C9.25452 9.08579 9.5903 8.75 10.0045 8.75Z",
    fill: "#323F48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 7C9.25 6.58579 9.58579 6.25 10 6.25H10.009C10.4232 6.25 10.759 6.58579 10.759 7C10.759 7.41421 10.4232 7.75 10.009 7.75H10C9.58579 7.75 9.25 7.41421 9.25 7Z",
    fill: "#323F48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.701044122aa1c652d1d4321a3bb35518.svg";
export { ForwardRef as ReactComponent };